import type { ModernSubscription, Subscription } from '../../types';

export function isModernSubscription(subscription: Subscription): subscription is ModernSubscription {
  return subscription.hasOwnProperty('state');
}
